var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10, _path11, _path12, _path13, _path14, _circle2, _path15, _path16, _path17, _path18, _path19, _path20, _circle3, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrypto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 54,
    viewBox: "0 0 85 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7439 52.1534L6.02729 40.2987C4.00998 39.5894 3.99953 36.7402 6.01158 36.0161L42.6574 22.8286C43.1655 22.6458 43.722 22.6498 44.2273 22.8399L79.2802 36.0276C81.2514 36.7692 81.2408 39.5613 79.264 40.2879L47.1262 52.1012C44.7463 52.976 42.136 52.9944 39.7439 52.1534Z",
    stroke: "#00FF94",
    strokeWidth: 0.737374
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6208 49.2862L10.4272 39.4222C9.16172 39.022 9.15569 37.2333 10.4185 36.8246L42.8733 26.3206C43.1521 26.2304 43.4526 26.2324 43.7302 26.3263L74.7741 36.8304C76.0141 37.2499 76.008 39.0059 74.7651 39.4168L44.9775 49.2643C43.8887 49.6243 42.7142 49.6319 41.6208 49.2862Z",
    fill: "#203376"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6826 31.3157L27.951 15.6982L61.193 25.1062L55.7363 40.7864L22.6826 31.3157Z",
    fill: "white",
    stroke: "#292B38",
    strokeWidth: 0.476648,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.145 35.3017L22.6699 31.3477L55.7361 40.7842L57.7442 43.9853L25.145 35.3017Z",
    fill: "white",
    stroke: "#292B38",
    strokeWidth: 0.476648,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9997 28.0961L61.1928 25.1104L55.7383 40.7857L57.7383 43.9762L62.9997 28.0961Z",
    fill: "#00FF94",
    stroke: "#292B38",
    strokeWidth: 0.476648,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5351 16.4468L36.1379 18.0123L31.2109 33.7978L32.9411 37.39L27.3386 35.9234L25.2129 32.1335L30.5351 16.4468Z",
    fill: "#00FF94"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2109 33.7978L36.1379 18.0123L30.5351 16.4468L25.2129 32.1335M31.2109 33.7978L32.9411 37.39L27.3386 35.9234L25.2129 32.1335M31.2109 33.7978L25.2129 32.1335",
    stroke: "#292B38",
    strokeWidth: 0.476648,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3154 32.4393L51.5373 28.8706L55.1377 29.9316L53.9161 33.5001L50.3154 32.4393Z",
    stroke: "#292B38",
    strokeWidth: 0.476648,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.9413,
    cy: 28.518,
    r: 6.02918,
    fill: "#1B3CF7",
    stroke: "#292B38",
    strokeWidth: 0.476648,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1797 23.9592L27.4481 8.3418L60.6901 17.7498L55.2334 33.43L22.1797 23.9592Z",
    fill: "white",
    stroke: "#292B38",
    strokeWidth: 0.476648,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6421 27.9452L22.167 23.9912L55.2332 33.4278L57.2413 36.6288L24.6421 27.9452Z",
    fill: "white",
    stroke: "#292B38",
    strokeWidth: 0.476648,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4978 20.7436L60.6909 17.7578L55.2363 33.4331L57.2363 36.6236L62.4978 20.7436Z",
    fill: "#00FF94",
    stroke: "#292B38",
    strokeWidth: 0.476648,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0331 9.0918L35.636 10.6573L30.7089 26.4428L32.4391 30.035L26.8366 28.5685L24.7109 24.7786L30.0331 9.0918Z",
    fill: "#00FF94"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7089 26.4428L35.636 10.6573L30.0331 9.0918L24.7109 24.7786M30.7089 26.4428L32.4391 30.035L26.8366 28.5685L24.7109 24.7786M30.7089 26.4428L24.7109 24.7786",
    stroke: "#292B38",
    strokeWidth: 0.476648,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8125 25.0843L51.0344 21.5156L54.6348 22.5767L53.4131 26.1451L49.8125 25.0843Z",
    stroke: "#292B38",
    strokeWidth: 0.476648,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.0155,
    cy: 21.0233,
    r: 6.02918,
    fill: "#1B3CF7",
    stroke: "#292B38",
    strokeWidth: 0.476648,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1615 21.3347C43.5037 21.281 43.7777 21.0756 43.8799 20.6181C44.0223 19.9928 43.5914 19.6258 42.9507 19.3523L43.2263 18.5123L42.7135 18.3437L42.4455 19.1604C42.3124 19.1166 42.1747 19.075 42.0371 19.0334L42.3073 18.2101L41.7945 18.0415L41.5189 18.8815C41.3285 18.8252 41.1098 18.7502 40.49 18.5431L40.3106 19.0898C40.7178 19.2158 40.9388 19.2596 40.9022 19.5355L40.1476 21.8355C40.049 22.0316 39.8939 21.9477 39.529 21.8205L39.2257 22.3966C40.1606 22.704 40.2535 22.7382 40.2535 22.7382L40.0174 23.4576L40.5302 23.6263L40.763 22.9169C40.9017 22.9662 41.0382 23.0111 41.1681 23.0538L40.9364 23.7598L41.4492 23.9285L41.6853 23.2091C42.5596 23.4449 43.205 23.4171 43.5474 22.6322C43.8206 22.0019 43.6094 21.6112 43.1615 21.3347ZM41.8503 19.6367C42.1399 19.732 43.0752 19.9398 42.8772 20.5432C42.688 21.1198 41.8042 20.7554 41.5145 20.6601L41.8503 19.6367ZM40.9764 22.3001L41.3461 21.1734C41.6924 21.2873 42.7845 21.5394 42.5679 22.1994C42.359 22.836 41.3227 22.414 40.9764 22.3001Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1387 16.1628L27.4071 0.54541L60.6491 9.9534L55.1923 25.6336L22.1387 16.1628Z",
    fill: "white",
    stroke: "#292B38",
    strokeWidth: 0.476648,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4751 20.0297L22 16.0757L55.0662 25.5123L57.0743 28.7133L24.4751 20.0297Z",
    fill: "white",
    stroke: "#292B38",
    strokeWidth: 0.476648,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3308 12.8275L60.5239 9.8418L55.0693 25.5171L57.0693 28.7076L62.3308 12.8275Z",
    fill: "#00FF94",
    stroke: "#292B38",
    strokeWidth: 0.476648,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8652 1.17578L35.468 2.74126L30.541 18.5268L32.2711 22.119L26.6687 20.6524L24.543 16.8625L29.8652 1.17578Z",
    fill: "#00FF94"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.541 18.5268L35.468 2.74126L29.8652 1.17578L24.543 16.8625M30.541 18.5268L32.2711 22.119L26.6687 20.6524L24.543 16.8625M30.541 18.5268L24.543 16.8625",
    stroke: "#292B38",
    strokeWidth: 0.476648,
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.8475,
    cy: 13.1073,
    r: 6.02918,
    fill: "#1B3CF7",
    stroke: "#292B38",
    strokeWidth: 0.476648,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9945 13.4186C43.3368 13.365 43.6107 13.1596 43.7129 12.702C43.8553 12.0767 43.4244 11.7097 42.7837 11.4363L43.0593 10.5963L42.5465 10.4276L42.2786 11.2443C42.1454 11.2005 42.0077 11.159 41.8701 11.1174L42.1403 10.2941L41.6275 10.1254L41.3519 10.9655C41.1615 10.9092 40.9428 10.8342 40.323 10.6271L40.1436 11.1738C40.5509 11.2998 40.7718 11.3436 40.7352 11.6195L39.9806 13.9195C39.882 14.1156 39.7269 14.0317 39.3621 13.9045L39.0587 14.4806C39.9936 14.788 40.0865 14.8222 40.0865 14.8222L39.8504 15.5416L40.3632 15.7102L40.596 15.0008C40.7347 15.0502 40.8712 15.0951 41.0011 15.1378L40.7695 15.8438L41.2822 16.0124L41.5183 15.2931C42.3926 15.5289 43.038 15.501 43.3804 14.7162C43.6536 14.0859 43.4424 13.6952 42.9945 13.4186ZM41.6833 11.7207C41.973 11.816 42.9082 12.0238 42.7102 12.6271C42.521 13.2038 41.6372 12.8393 41.3475 12.7441L41.6833 11.7207ZM40.8094 14.3841L41.1791 13.2574C41.5254 13.3713 42.6175 13.6233 42.4009 14.2834C42.192 14.92 41.1557 14.498 40.8094 14.3841Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrypto);
export default __webpack_public_path__ + "static/media/crypto.20f67fecb6ac211af2eff0af18bd712a.svg";
export { ForwardRef as ReactComponent };